import { useTranslation } from 'react-i18next'

export const getColumnTitle = (translationKey: string, className?: string) => {
  const { t } = useTranslation()
  return <span className={className} style={{ whiteSpace: 'nowrap' }}>{t(translationKey)}</span>
}
